import dayjs, { Dayjs } from "dayjs";

const ISOToDayJs = (value: string | undefined | Dayjs | null) =>
  value ? dayjs(value) : "";

export default ISOToDayJs;
